import { html, css, nothing } from "lit";
import { OutDesignNodeElement } from "./OutDesignNodeElement";
import { customElement } from "lit/decorators.js";

@customElement("od-inline")
export class OutDesignInlineElement extends OutDesignNodeElement {

  static styles = [
    OutDesignNodeElement.styles,
    css`
    :host {
      display: inline;
      position: relative;
      outline: 2px dashed #F67D31;
      background-color: #F67D3113;
    }

    :host(:not(:hover):not([structureViewEnabled])) {
      outline: none;
      background-color: transparent;
    }

    od-meta {
      font-family: monospace;
      color: #F67D31;
      margin-right: 4px;
      font-size: 0.8em;
    }

    :host(:not(:hover):not([structureViewEnabled])) od-meta {
      display: none;
    }

    :host([originalStylesEnabled]) ::slotted(em),
    :host([originalStylesEnabled]) ::slotted(i),
    :host([originalStylesEnabled]) ::slotted(strong),
    :host([originalStylesEnabled]) ::slotted(bold) {
      font-weight: inherit;
      font-style: inherit;
    }
  `];

  render() {
    return html`
      <span data-role="wrapper" data-indesign-style=${this.originalInDesignStyle || nothing}>
        <od-meta
          .type=${this.type}
          .attr=${this.attr}
          .data=${this.data}
        ></od-meta>

        <slot></slot>
      </span>
    `;
  }
}